import React from 'react'
import { Box, Container, Paper, Stack, Text } from '@mantine/core'
import { IconAlertTriangle } from '@tabler/icons-react'

const ErrorPage: React.FC = () => {
  return (
    <Container
      size="sm"
      style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Paper
        p="xl"
        radius="lg"
        style={{
          background: 'linear-gradient(135deg, #F8FAFC 0%, rgba(255,255,255,0.9) 100%)',
          border: '1px solid #E5E7EB30',
          textAlign: 'center',
          width: '100%',
        }}
      >
        <Stack gap="lg" align="center">
          <Box
            style={{
              padding: '20px',
              borderRadius: '50%',
              backgroundColor: '#3B82F620',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <IconAlertTriangle size={48} color="#3B82F6" />
          </Box>
          <Stack gap="xs" align="center">
            <Text size="xl" fw={700} c="gray.8">
              页面访问错误
            </Text>
            <Text size="sm" c="dimmed" fw={500}>
              抱歉，您访问的页面参数有误或已失效
            </Text>
          </Stack>
        </Stack>
      </Paper>
    </Container>
  )
}

export default ErrorPage
